<app-dialog-close-button class="close-button" (closed)="close()"></app-dialog-close-button>
<h2 vng-dialog-title class="text-center">
    Choose a plan to downgrade to:
</h2>

<vng-dialog-content class="top-space mb-small" style="display:flex; justify-content:center; align-items:center; gap:15px">
    <div class="starter text-center">
        <h2>Starter</h2>
        <h1 class="accent">${{starterMonthlyPrice}}/mo*</h1>
        <h4 class="accent">*Billed annually at ${{starterYearlyPrice}} per user</h4>
        <p>
            Access to Technical Support
            Insert Images into FlyCuts and FlyPlates,
            All Text Styling, Advanced Search
        </p>
        <button (click)="chooseStarter()" vng-button variant="primary">
            Choose Starter
        </button>
    </div>
    <div class="freemium text-center">
        <h2>Freemium</h2>
        <h1 class="accent">Free</h1>
        <h4 class="accent" style="visibility: hidden;">*Billed annually at FREE per user</h4>
        <p>
            Basic Font Styling, Spell Check, Import FlyCuts, Video Giphy Support
        </p>
        <button (click)="chooseFreemium()" class="text-center" vng-button variant="primary">
            Choose Freemium
         </button>
    </div>
</vng-dialog-content>
